import React, { useRef } from 'react';

import { timeValidation } from '../utils';
import './TimePicker.css';

const TimePicker = (props) => {
  const {
    time: { hours, minutes },
    period
  } = props;

  const minutesRef = useRef();

  const onFocus = (e) => {
    e.target.select();
    props.setTime();
  };

  const setTime = (name, value) => {
    if (value.length <= 2) {
      props.onChange({ period, timeMetric: name, value: value });
    } else {
      props.onChange({ period, timeMetric: name, value: value.slice(0, 2) });
    }
  };

  const onHoursChange = (e) => {
    const { name, value } = e.target;

    if (!timeValidation({ name, value }, hours, period)) {
      return;
    }

    if (value.length > 2) {
      minutesRef.current.focus();
      setTime('minutes', value.slice(-1));
      return;
    }

    if (value.length === 2) {
      minutesRef.current.focus();
    }

    setTime(name, value);
  };

  const onMinutesChange = (e) => {
    const { name, value } = e.target;

    if (!timeValidation({ name, value }, hours, period)) {
      return;
    }

    setTime(name, value);
  };

  return (
    <section className="TimePicker">
      <div className="TimePicker_Field Hours">
        <input
          className="TimePicker_Field_Input"
          type="text"
          value={hours}
          placeholder="00"
          onFocus={onFocus}
          onBlur={props.setTime}
          onChange={onHoursChange}
          name="hours"
        />
      </div>

      <div className="TimePicker_Field">
        <input
          className="TimePicker_Field_Input"
          ref={minutesRef}
          type="text"
          value={minutes}
          placeholder="00"
          onFocus={onFocus}
          onBlur={props.setTime}
          onChange={onMinutesChange}
          name="minutes"
        />
      </div>
    </section>
  );
};

export default TimePicker;
